import React, { useRef, useState, useEffect } from "react";
import { MoreInfo } from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import { Tooltip } from "@paylixecommerce/shared/components";

const TextArea = ({ tooltip, label, onKeyDown, autoresize, onBlur, onFocus, name, isError, value, noteUnder, wrapperClassName, className, placeholder, rows, handleChange, values, note, touched, errors }) => {

	let isValid = isError ? isError : errors[name] && touched[name];

	const textAreaRef = useRef(null);
	const [text, setText] = useState("");
	const [textAreaHeight, setTextAreaHeight] = useState("auto");
	const [parentHeight, setParentHeight] = useState("auto");

	useEffect(() => {
		if(autoresize && textAreaRef.current) {
			setParentHeight(`${textAreaRef.current.scrollHeight}px`);
			setTextAreaHeight(`${textAreaRef.current.scrollHeight}px`);
		}
	}, [text]);

	const onChangeHandler = (event) => {
		if(autoresize) {
			setTextAreaHeight("auto");
			setParentHeight(`${textAreaRef.current.scrollHeight}px`);
			setText(event.target.value);
		}

		if (handleChange) {
			handleChange(event);
		}
	};

	return <div className={`mb-4 ${wrapperClassName ? wrapperClassName : ''}`} style={autoresize ? { minHeight: parentHeight } : {}}>
		{label || tooltip ? <label className="paylixecommerce-label" htmlFor={name}>
			{label || "&nbsp;"}
			{tooltip &&
				<span className="ml-1">
					<Tooltip tooltipText={tooltip} name={name} >
						<MoreInfo />
					</Tooltip>
				</span>
			}
		</label> : null}

		{note && !noteUnder && <p className="paylixecommerce-note">{note}</p>}
		<textarea
			onKeyDown={onKeyDown}
			ref={textAreaRef}
			autoComplete="off"
			id={name}
			name={name}
			placeholder={placeholder}
			onChange={onChangeHandler}
			value={value ? value : values[name]}
			className={`paylixecommerce-input textarea ${className} ${isValid && 'is-invalid'}`}
			rows={rows || 3}
			style={autoresize ? { height: textAreaHeight } : {}}
			onBlur={onBlur}
			onFocus={onFocus}
		/>
		{isValid && <div className="invalid-feedback">{errors[name]}</div>}
		{note && noteUnder && <p className="paylixecommerce-note">{note}</p>}
	</div>
}

export default TextArea;
